import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2069_3961)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        "fill-opacity": ".52",
        d: "M8 .593C8 .23 7.713.005 7.276.005L.719 0C.282 0 0 .225 0 .588c0 .196.09.358.191.564L3.33 7.451c.21.417.402.549.668.549.267 0 .463-.132.674-.549l3.133-6.299C7.91.951 8 .789 8 .593"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2069_3961" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h8v8H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }